class ImageCarousel {
    constructor(container) {
        if (!container) {
            console.error('ImageCarousel: Container element is required');
            return null;
        }

        this.container = container;
        this.currentSlideIndex = 0;
        this.slides = [];
        this.dots = [];
        this.autoSlideInterval = null;
        this.isInitialized = false;
        this.boundEventHandlers = {};


        // Initialize immediately
        setTimeout(() => {
            this.init();
        }, 100);

        return this;
    }

    init() {
        if (this.isInitialized || !this.container) return;

        try {

            this.render();
            this.bindEvents();
            this.startAutoSlide();
            this.isInitialized = true;
        } catch (error) {
            console.error('Error initializing ImageCarousel:', error);
        }
    }

    render() {
        const carouselData = [
            {
                title: "HEMA-CORDIAL",
                subtitle: "Unique remedy for menstrual complaints and functional uterine bleeding. Contains Asoka Bark, Ashwagandha, Lodhra, Shatavari.",
                buttonText: "Learn More",
                buttonLink: "/product/1",
                slideClass: "carousel-slide-1",
                backgroundImage: "/photos/hema-coridal.jpeg"
            },
            {
                title: "GASSO-WIN",
                subtitle: "Pure herbal syrup for gastric complaints with 18 herbal ingredients including Mustak, Pudina, Arjun, Haritaki.",
                buttonText: "Learn More",
                buttonLink: "/product/2",
                slideClass: "carousel-slide-2",
                backgroundImage: "/photos/gasso-win.jpg"
            },
            {
                title: "VITAL COMPOUND",
                subtitle: "Natural herbal restorative tonic with adaptogens including Moosli Safed, Ashwagandha, Satawari, Honey.",
                buttonText: "Learn More",
                buttonLink: "/product/3",
                slideClass: "carousel-slide-3",
                backgroundImage: "/photos/vital-compound.jpeg"
            },
            {
                title: "COUGH-CO",
                subtitle: "Time-tested herbal cough syrup with Vasaka, Madhuyashti, Tulsi, Honey for respiratory issues.",
                buttonText: "Learn More",
                buttonLink: "/product/4",
                slideClass: "carousel-slide-4",
                backgroundImage: "/photos/cough-co.jpeg"
            },
            {
                title: "LIVWIN",
                subtitle: "Advanced liver tonic for hepatic disorders. Formulated with Kalmegh, Bhumi Amla, Kutki for liver detox and protection.",
                buttonText: "Learn More",
                buttonLink: "/product/5",
                slideClass: "carousel-slide-5",
                backgroundImage: "/photos/liwin.jpeg"
            },
            {
                title: "ACHE-WIN OIL",
                subtitle: "External pain relief oil for joint and muscle pain. Contains Wintergreen, Eucalyptus, Camphor for instant relief.",
                buttonText: "Learn More",
                buttonLink: "/product/6",
                slideClass: "carousel-slide-6",
                backgroundImage: "/photos/ache-win.jpeg"
            },
            {
                title: "VITAL DROPS (Pediatric)",
                subtitle: "Safe herbal drops for children's digestive health. Gentle formulation with Saunf, Pudina, Hing for kids.",
                buttonText: "Learn More",
                buttonLink: "/product/7",
                slideClass: "carousel-slide-7",
                backgroundImage: "/photos/vital-drops.jpeg"
            },
            {
                title: "DYLOWIN TABLET",
                subtitle: "Natural diabetes management tablets. Contains Karela, Jamun, Methi, Gudmar for blood sugar control.",
                buttonText: "Learn More",
                buttonLink: "/product/8",
                slideClass: "carousel-slide-8",
                backgroundImage: "/photos/dylowin_tablets.jpeg"
            }
        ];

        // Create HTML using DOM elements instead of template strings
        const carouselWrapper = document.createElement('div');
        carouselWrapper.className = 'carousel-wrapper';

        // Create slides using DOM
        carouselData.forEach((slide, index) => {
            const productId = index + 1;

            const slideDiv = document.createElement('div');
            slideDiv.className = `carousel-slide ${slide.slideClass}`;
            if (index === 0) slideDiv.classList.add('active');
            slideDiv.style.backgroundImage = `url('${slide.backgroundImage}')`;

            const overlay = document.createElement('div');
            overlay.className = 'carousel-overlay';

            const content = document.createElement('div');
            content.className = 'carousel-content';

            const title = document.createElement('h2');
            title.className = 'carousel-title';
            title.textContent = slide.title;

            const subtitle = document.createElement('p');
            subtitle.className = 'carousel-subtitle';
            subtitle.textContent = slide.subtitle;

            const button = document.createElement('button');
            button.className = 'carousel-btn';
            button.textContent = slide.buttonText;
            button.setAttribute('data-product-id', productId);
            button.setAttribute('data-product-name', slide.title);

            content.appendChild(title);
            content.appendChild(subtitle);
            content.appendChild(button);

            slideDiv.appendChild(overlay);
            slideDiv.appendChild(content);

            carouselWrapper.appendChild(slideDiv);
        });

        // Create navigation arrows
        const prevArrow = document.createElement('button');
        prevArrow.className = 'carousel-arrow prev';
        prevArrow.type = 'button';
        prevArrow.setAttribute('aria-label', 'Previous slide');
        prevArrow.innerHTML = '&#10094;';

        const nextArrow = document.createElement('button');
        nextArrow.className = 'carousel-arrow next';
        nextArrow.type = 'button';
        nextArrow.setAttribute('aria-label', 'Next slide');
        nextArrow.innerHTML = '&#10095;';

        // Create navigation dots
        const navigation = document.createElement('div');
        navigation.className = 'carousel-navigation';

        carouselData.forEach((_, index) => {
            const dot = document.createElement('button');
            dot.className = 'carousel-dot';
            if (index === 0) dot.classList.add('active');
            dot.type = 'button';
            dot.setAttribute('data-slide', index);
            dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
            navigation.appendChild(dot);
        });

        // Clear container and append elements
        this.container.innerHTML = '';
        this.container.appendChild(carouselWrapper);
        this.container.appendChild(prevArrow);
        this.container.appendChild(nextArrow);
        this.container.appendChild(navigation);

        // Debug: Log the actual HTML to see what was generated
        const generatedBtns = this.container.querySelectorAll('.carousel-btn');
        generatedBtns.forEach((btn, i) => {
            console.log(`Button ${i}: data-product-id="${btn.getAttribute('data-product-id')}" data-product-name="${btn.getAttribute('data-product-name')}"`);
        });

        // Get elements after rendering
        this.slides = this.container.querySelectorAll('.carousel-slide');
        this.dots = this.container.querySelectorAll('.carousel-dot');

    }

    bindEvents() {
        const prevBtn = this.container.querySelector('.carousel-arrow.prev');
        const nextBtn = this.container.querySelector('.carousel-arrow.next');

        // Store bound functions for proper cleanup
        this.boundEventHandlers.prevClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.previousSlide();
        };

        this.boundEventHandlers.nextClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.nextSlide();
        };

        this.boundEventHandlers.mouseEnter = () => this.stopAutoSlide();
        this.boundEventHandlers.mouseLeave = () => this.startAutoSlide();

        if (prevBtn) {
            prevBtn.addEventListener('click', this.boundEventHandlers.prevClick);
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', this.boundEventHandlers.nextClick);
        }

        // Bind dot clicks
        this.dots.forEach((dot, index) => {
            const dotHandler = (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.goToSlide(index);
            };
            dot.addEventListener('click', dotHandler);
            // Store handler for cleanup
            dot._handler = dotHandler;
        });

        // Bind carousel button clicks
        const carouselBtns = this.container.querySelectorAll('.carousel-btn');

        carouselBtns.forEach((btn, btnIndex) => {
            const productId = btn.getAttribute('data-product-id');
            const productName = btn.getAttribute('data-product-name');

            const btnHandler = function(e) {
                e.preventDefault();
                e.stopPropagation();

                const clickedProductId = e.currentTarget.getAttribute('data-product-id');
                const clickedProductName = e.currentTarget.getAttribute('data-product-name');

                // Use React Router style navigation
                const targetUrl = `/product/${clickedProductId}`;

                // Push the new route to history and trigger React Router
                window.history.pushState({}, '', targetUrl);

                // Dispatch a popstate event to trigger React Router
                const navEvent = new PopStateEvent('popstate');
                window.dispatchEvent(navEvent);
            };

            btn.addEventListener('click', btnHandler);
            btn._handler = btnHandler;
        });


        // Mouse hover events
        this.container.addEventListener('mouseenter', this.boundEventHandlers.mouseEnter);
        this.container.addEventListener('mouseleave', this.boundEventHandlers.mouseLeave);

        // Visibility change handler
        this.boundEventHandlers.visibilityChange = () => {
            if (document.hidden) {
                this.stopAutoSlide();
            } else {
                this.startAutoSlide();
            }
        };
        document.addEventListener('visibilitychange', this.boundEventHandlers.visibilityChange);
    }

    showSlide(index) {
        if (!this.slides || !this.slides.length || index < 0 || index >= this.slides.length) {
            console.warn('Invalid slide index:', index);
            return;
        }

        // Remove active class from all slides and dots
        this.slides.forEach(slide => slide.classList.remove('active'));
        this.dots.forEach(dot => dot.classList.remove('active'));
        
        // Add active class to current slide and dot
        this.slides[index].classList.add('active');
        if (this.dots[index]) {
            this.dots[index].classList.add('active');
        }
        
        this.currentSlideIndex = index;
    }

    nextSlide() {
        if (!this.slides.length) return;
        const nextIndex = (this.currentSlideIndex + 1) % this.slides.length;
        this.showSlide(nextIndex);
    }

    previousSlide() {
        if (!this.slides.length) return;
        const prevIndex = (this.currentSlideIndex - 1 + this.slides.length) % this.slides.length;
        this.showSlide(prevIndex);
    }

    goToSlide(index) {
        this.showSlide(index);
    }

    startAutoSlide() {
        this.stopAutoSlide();
        if (this.slides.length > 1) {
            this.autoSlideInterval = setInterval(() => {
                this.nextSlide();
            }, 5000);
        }
    }

    stopAutoSlide() {
        if (this.autoSlideInterval) {
            clearInterval(this.autoSlideInterval);
            this.autoSlideInterval = null;
        }
    }

    destroy() {        
        this.stopAutoSlide();
        
        // Remove all event listeners
        const prevBtn = this.container.querySelector('.carousel-arrow.prev');
        const nextBtn = this.container.querySelector('.carousel-arrow.next');
        
        if (prevBtn && this.boundEventHandlers.prevClick) {
            prevBtn.removeEventListener('click', this.boundEventHandlers.prevClick);
        }
        
        if (nextBtn && this.boundEventHandlers.nextClick) {
            nextBtn.removeEventListener('click', this.boundEventHandlers.nextClick);
        }
        
        // Remove dot event listeners
        this.dots.forEach(dot => {
            if (dot._handler) {
                dot.removeEventListener('click', dot._handler);
            }
        });

        // Remove carousel button event listeners
        const carouselBtns = this.container.querySelectorAll('.carousel-btn');
        carouselBtns.forEach(btn => {
            if (btn._handler) {
                btn.removeEventListener('click', btn._handler);
            }
        });

        
        // Remove container event listeners
        this.container.removeEventListener('mouseenter', this.boundEventHandlers.mouseEnter);
        this.container.removeEventListener('mouseleave', this.boundEventHandlers.mouseLeave);
        
        // Remove document event listener
        document.removeEventListener('visibilitychange', this.boundEventHandlers.visibilityChange);
        
        // Clear container
        this.container.innerHTML = '';
        this.isInitialized = false;
        this.slides = [];
        this.dots = [];
        this.boundEventHandlers = {};
    }

    // Public method to check if carousel is working
    isWorking() {
        return this.isInitialized && this.slides.length > 0;
    }

}

export default ImageCarousel;